import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IRoleMast } from "../../models/RoleMast";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { EmptyRole } from "./EmptyRole";

const schema = yup.object({
    role_Name: yup.string().required("Role Name is required*"),
    role_Description: yup.string().nullable()
});

interface Iprops {
    singleData: IRoleMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IRoleMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData])

    const saveToDB = async (body: IRoleMast) => {
        const method = props.singleData.role_ID ? "PUT" : "POST";
        const message = props.singleData.role_ID ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("Role_Mast", method, body, null, props.toast);

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success',  detail: message, life: 3000 });
            reset(EmptyRole);
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyRole);
    }

    function onSubmit(data: IRoleMast) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Role" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput required label="Role Name" control={control} name="role_Name" error={errors.role_Name?.message} />
                <JVInput label="Description" control={control} name="role_Description" error={errors.role_Description?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>

            </form>
        </Dialog>
    );
}
